import { TutorialStep } from '../components/Tutorial';

export const HOME_TUTORIAL_KEY = 'pronunciation_tutorial_completed';
export const INTERVIEW_TUTORIAL_KEY = 'interview_tutorial_completed';

export const homeTutorialSteps: TutorialStep[] = [
  {
    target: '#target-text',
    title: 'Practice Sentence',
    content: 'This is the sentence you\'ll practice. You can edit it to practice any text you want!',
    placement: 'bottom',
  },
  {
    target: '#pro-toggle',
    title: 'Pro Mode',
    content: 'Enable Pro Mode for detailed phoneme analysis, timing breakdown, and AI-powered tips.',
    placement: 'bottom',
  },
  {
    target: '#record-button',
    title: 'Record Your Voice',
    content: 'Click this button to start recording. Read the sentence clearly, then click again to stop.',
    placement: 'top',
  },
  {
    target: '#interview-button',
    title: 'Interview Practice',
    content: 'Practice job interviews with AI-generated questions and get feedback on your answers.',
    placement: 'bottom',
  },
  {
    target: '#user-profile',
    title: 'Your Progress',
    content: 'Track your practice time, sessions, and streaks here. Keep practicing to improve!',
    placement: 'left',
  },
];

export const interviewTutorialSteps: TutorialStep[] = [
  {
    target: '#interview-onboarding',
    title: 'Welcome to Interview Practice',
    content: 'Practice answering interview questions and get AI-powered feedback on your responses.',
    placement: 'bottom',
  },
];
